// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b > div {
    height: 1px;
    align-self: center;
    margin-left: 10px;
    background-color: #868686;
}

.b{
    margin-bottom:10px;
}

.at{
    margin-left:5px;
}

.tc {
    align-self: flex-start;
    background-color: #b9b9b9;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/rest/rest.overview/rest.overview.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B","sourcesContent":[".b > div {\n    height: 1px;\n    align-self: center;\n    margin-left: 10px;\n    background-color: #868686;\n}\n\n.b{\n    margin-bottom:10px;\n}\n\n.at{\n    margin-left:5px;\n}\n\n.tc {\n    align-self: flex-start;\n    background-color: #b9b9b9;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
